<template>
  <section
    v-if="user && user.id && course"
    class="c-section c-section--exam" :class="{full : isFullView}"
  >
    <ModalReport :user="user" :course="course.title"></ModalReport>
    <Header :course="course" :goBack="goBack"></Header>

    <transition name="fade" mode="out-in">
      <Welcome
        v-if="step == 1"
        key="welcome"
        :userData="user"
        :step.sync="step"
        :exam.sync="exam"
        :course="course"
        :profile-completed="profileCompleted"
        :settings="examSettings"
      ></Welcome>
      <Test
        v-else-if="step == 2"
        key="workspace"
        :user="user"
        :exam.sync="exam"
        :step.sync="step"
        :examSettings.sync="examSettings"
      ></Test>
      <Summary
        v-else-if="isSummaryStep && course" key="summary"
        :user="user"
        :step.sync="step"
        :course="course"
        :exam.sync="exam"
        :goBack="goBack"
      >
      </Summary>
      <Certificate
        v-else-if="isCertificateStep && course" key="certificate"
        :user="user"
        :course="course"
        :exam.sync="exam"
        :examSettings.sync="examSettings"
      >
      </Certificate>
    </transition>
  </section>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

import Header from '../components/exam/Header.vue';
import Welcome from '../components/exam/Welcome.vue';
import Test from '../components/exam/Test.vue';
import Summary from '../components/exam/Summary.vue';
import Certificate from '../components/exam/Certificate.vue';
import ModalReport from '../components/lection/modals/ModalReport.vue';

export default {
  data() {
    return {
      user: null,
      step: 0,
      course: '',
      profileCompleted: false,
      examSettings: '',
      exam: '',
    }
  },
  components: {
    Header,
    Welcome,
    Test,
    Summary,
    Certificate,
    ModalReport,
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    isSummaryStep: function() {
      return (this.step == 3 && !this.exam.approved) ? true : false;
    },
    isCertificateStep: function() {
      return (this.step == 3 && this.exam.approved) ? true : false;
    },

    goBack: function() {
      if (this.course && this.course.url) {
        const courseLectionURL = this.course.url.split('/curso/');

        return (this.$route.params.speciality_id)
          ? `/curso/${this.$route.params.speciality_id}/${courseLectionURL[1]}`
          : `/curso/${courseLectionURL[1]}`;
      }

      return false;
    },
  },
  watch: {
    userData(data) {
      this.user = data;

      this.getExam();
      this.getSolvedExam();
    },
  },
  mounted() {
    this.user = this.userData;

    if (this.user && this.user.id) {
      this.getExam();
      this.getSolvedExam();
    }
  },
  methods: {
    getExam: function() {
      const speciality = (this.$route.params.speciality_id) ? `&specialityId=${this.$route.params.speciality_id}` : '';
      const url = `${window.arcux.site}/api/v1/courses/${this.$route.params.course_id}/exams/${this.$route.params.exam_id}?userId=${this.user.id}${speciality}`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.course           = data.course;
        this.profileCompleted = data.profile_completed;
        this.examSettings     = data;
      })
      .catch(err => {
        // window.location.href = `${window.arcux.site}`;

        throw err;
      })
    },
    getSolvedExam: function() {
      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/solved-exams?examId=${this.$route.params.exam_id}`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        data.originalQuestions = data.questions;

        this.exam = data;

        if (!data.approved) {
          const isCompletedExam = data.questions.filter(q => (q.answer > 0 || q.answer.length > 0)).length == data.questions.length;

          if(isCompletedExam) {
            this.step = 3;
          } else {
            this.step = 2;
          }
        } else {
          this.step = 3;
        }
      })
      .catch(err => {
        this.step = 1;

        throw err;
      })
    },
  },
}
</script>
